import { Link } from 'react-router-dom';
import { tr } from '@repo/locale';
import { DotSeparator } from '@repo/ui';

import Logo from '@shared/components/Logo';
import {
  COMPANY_ADDRES_LINE_1,
  COMPANY_ADDRES_LINE_2,
  COMPANY_KRS,
  COMPANY_NAME,
  COMPANY_NIP,
  COMPANY_REGON,
} from '@shared/constants/constants';

import { RouteName } from '@router/routeNames';
import { ROUTE_PATHS } from '@router/paths';

export default function DesktopFooter() {
  return (
    <div className="bg-soft-orange border-stroke-base-medium hidden items-center justify-between border-t px-10 py-5 md:flex md:shrink-0 md:p-4">
      <div className="flex items-center gap-6">
        <Logo width={120} className="text-brand" />
        <div className="text-body flex items-center gap-3 text-sm">
          <p>{COMPANY_NAME}</p>
          <p>{COMPANY_ADDRES_LINE_1}</p>
          <p>{COMPANY_ADDRES_LINE_2}</p>
        </div>
        <div className="text-body hidden items-center gap-3 text-sm lg:flex">
          <DotSeparator color="bg-gray" />
          <p>NIP: {COMPANY_NIP}</p>
        </div>
        <div className="text-body hidden items-center gap-3 text-sm xl:flex">
          <DotSeparator color="bg-gray" />
          <p>REGON: {COMPANY_REGON}</p>
          <DotSeparator color="bg-gray" />
          <p>KRS: {COMPANY_KRS}</p>
        </div>
      </div>
      <div className="text-body flex gap-3 text-right text-sm">
        <Link to={ROUTE_PATHS[RouteName.ACCOUNT_CONTACT]} className="hover:text-brand-strong">
          {tr('account:menu.contact')}
        </Link>
        <Link to={ROUTE_PATHS[RouteName.ACCOUNT_REGULATIONS]} className="hover:text-brand-strong">
          {tr('account:regulations.header')}
        </Link>
      </div>
    </div>
  );
}
